var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignalBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h104v104H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.214 63.6h4.143c3.432 0 6.214 2.82 6.214 6.3v16.8c0 3.48-2.782 6.3-6.214 6.3h-4.143C15.782 93 13 90.18 13 86.7V69.9c0-3.48 2.782-6.3 6.214-6.3zM39.93 46.8h4.142c3.432 0 6.215 2.82 6.215 6.3v33.6c0 3.48-2.783 6.3-6.215 6.3H39.93c-3.432 0-6.215-2.82-6.215-6.3V53.1c0-3.48 2.783-6.3 6.215-6.3zM60.643 30h4.143C68.218 30 71 32.82 71 36.3v50.4c0 3.48-2.782 6.3-6.214 6.3h-4.143c-3.432 0-6.214-2.82-6.214-6.3V36.3c0-3.48 2.782-6.3 6.214-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44D5E9",
    fillRule: "nonzero",
    d: "M80.375 13h4.25C88.145 13 91 15.792 91 19.237v66.526C91 89.208 88.146 92 84.625 92h-4.25C76.855 92 74 89.208 74 85.763V19.237C74 15.792 76.854 13 80.375 13z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalBars);
export default __webpack_public_path__ + "static/media/signal-bars.9a91b8c2100980b04ca2dd796e3f2e55.svg";
export { ForwardRef as ReactComponent };